import React from 'react'

import { Col, Form } from '_zari/core'

import { SelectCentroCosto } from 'sharedComponents/select'

const CentroCostoNivel1FormGroup = ({ value, setValue, limpiarTabla }) => {
  const oneRowTrigger = React.useCallback(
    primeraFila => {
      setValue(primeraFila._id)
    },
    [setValue]
  )

  return (
    <Form.Group>
      <Form.Label text='Centro Costo 1' htmlFor='centrocostonivel1' md={4} />
      <Col md={8}>
        <SelectCentroCosto
          id={`select-centroCostoNivel1`}
          name={`select-centroCostoNivel1`}
          onChange={e => {
            setValue(e.target.value)
            limpiarTabla()
          }}
          value={value}
          nivel={1}
          oneRowTrigger={oneRowTrigger}
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(CentroCostoNivel1FormGroup)
